import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getMembers=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_MEMBERS_START
    })
    await axios.get('/members')
            .then(response=>dispatch({
                type:actionTypes.GET_MEMBERS_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_MEMBERS_FAIL,
                payload:getMessage(error)
            }))
}